import { render, staticRenderFns } from "./CommunicationSetting.vue?vue&type=template&id=cde58358&scoped=true"
import script from "./CommunicationSetting.vue?vue&type=script&lang=js"
export * from "./CommunicationSetting.vue?vue&type=script&lang=js"
import style0 from "./CommunicationSetting.vue?vue&type=style&index=0&id=cde58358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde58358",
  null
  
)

export default component.exports